import { render, staticRenderFns } from "./manage_customer_detail.vue?vue&type=template&id=dcec498c"
import script from "./manage_customer_detail.vue?vue&type=script&lang=js"
export * from "./manage_customer_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports